import type { SnippetsPluginOptions } from '@atlassian/editor-plugin-snippets';

import { expValEquals } from '@confluence/feature-experiments';

import { createConfluenceSnippetsProvider } from '../provider/confluenceSnippetsProvider.ts';
import { recordSnippetInsert } from '../store/snippetsStore.ts';

import { useIsSnippetCreateEnabled } from './embedded-confluence/useIsSnippetCreateEnabled.ts';
import type { UseHandleCreateSnippetProps } from './modals/useHandleCreateSnippet.ts';
import { useCreateSnippetFromRequest } from './modals/useCreateSnippetFromRequest.ts';
import { useOpenSnippetPanel } from './panel/useOpenSnippetPanel.ts';

export const useConfluenceSnippetsPluginOptions = (
	userId: string | undefined,
	createSnippetHandlerProps?: UseHandleCreateSnippetProps,
): SnippetsPluginOptions | undefined => {
	const openTemplateGallery = useOpenSnippetPanel();
	const createSnippetCallback = useCreateSnippetFromRequest(createSnippetHandlerProps);
	const isSnippetCreateEnabled = useIsSnippetCreateEnabled();
	const onCreateSnippet =
		createSnippetHandlerProps && isSnippetCreateEnabled ? createSnippetCallback : undefined;

	if (
		!expValEquals('platform_editor_blocks_conf', 'isEnabled', true) ||
		!expValEquals('platform_editor_snippets_plugin_confluence', 'isEnabled', true)
	) {
		return undefined;
	}

	return {
		openTemplateGallery,
		...(onCreateSnippet && { onCreateSnippet }),
		snippetsProvider: createConfluenceSnippetsProvider(() => userId),
		onSnippetInserted: ({ snippet }): void => {
			recordSnippetInsert(snippet.snippetId);
		},
	};
};
